// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"664":"2103ee40","787":"4da30140"}[chunkId] + ".chunk.js";
};